
// region JS Imports

// region External Modules
import $ from "jquery"

// endregion External Modules

// region Private Modules
import * as Routes from "plugins/js-routes"
import I18n from "plugins/i18n-js"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"

import {
  FollowTypes,
} from "app/resources/neighbourhood_followings/subscribe"
// endregion Private Modules

// region Public Components
import {
  Factory as DropdownContentFactory,
} from "./components/dropdown_content"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports



interface Input {
  user_authentication_handle: string,

  neighbourhood_id: string | number,

  follow_type: FollowTypes,
}

const init = ({user_authentication_handle, neighbourhood_id, follow_type}: Input) => {
  q_ajax_3({
    url:      Routes.apps_spacious_website_partials_neighbourhoods_follow_type_select_dropdown_path(
      {
        locale:                     I18n.locale,
        neighbourhood_id:           neighbourhood_id,
        follow_type:                follow_type,
        user_authentication_handle: user_authentication_handle,
      },
    ),
    method:   "GET",
    dataType: "html",
  })
  .then(({data}) => {
    if ($(".cell--neighbourhoods--follow-type-select-dropdown").length > 0) {
      return
    }
    $("body").append(data)

    const dropdown_content = DropdownContentFactory.instance({user_authentication_handle, neighbourhood_id, follow_type})

    dropdown_content.on("dropdown_closed", ()=> {
      DropdownContentFactory.destroy()
    })

  })
}


export default {init}
